// constants
import {
    CLICK_LABELS,
    DO_CLICK_ACTIONS,
    DO_IMPRESSION_ACTIONS,
    IMPRESSION_LABELS,
    SCREEN_NAME,
} from "@dineout-payment-success-ui/analytics/constants";

// interfaces
import { IEventContext, IScreenViewBookingSuccess } from "@dineout-payment-success-ui/interfaces/AnalyticsEvents";

// internal-deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const screenViewBookingSuccess = (
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
    { billAmount, restId, eventId, dealCategory }: IScreenViewBookingSuccess,
): void => {
    screenViewEvent({
        category: SCREEN_NAME.BOOKED_DEAL_DETAIL,
        action: SCREEN_NAME.BOOKED_DEAL_DETAIL,
        context: JSON.stringify({
            billAmount,
            restId,
            eventId,
            dealCategory,
        }),
    });
};

export const impressionEventNudge = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { orderId, restaurantId, eventId, dealCategory, guests }: IEventContext,
): void => {
    impressionEvent({
        category: SCREEN_NAME.BOOKED_DEAL_DETAIL,
        action: DO_IMPRESSION_ACTIONS.BOOKING_DETAILS,
        label: IMPRESSION_LABELS.EVENT_NUDGE_IMPRESSION,
        context: JSON.stringify({
            bookingId: orderId,
            restId: restaurantId,
            eventId,
            dealCategory,
            guests,
        }),
    });
};

export const clickEventNudge = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { orderId, restaurantId, eventId, dealCategory, guests }: IEventContext,
): void => {
    clickEvent({
        category: SCREEN_NAME.BOOKED_DEAL_DETAIL,
        action: DO_CLICK_ACTIONS.BOOKING_DETAILS,
        label: CLICK_LABELS.EVENT_NUDGE_CLICK,
        context: JSON.stringify({
            bookingId: orderId,
            restId: restaurantId,
            eventId,
            dealCategory,
            guests,
        }),
    });
};

export const clickDoneEventCTA = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    isCheckoutFlow: boolean,
    { orderId, restaurantId, eventId, dealCategory, guests }: IEventContext,
): void => {
    clickEvent({
        category: isCheckoutFlow ? SCREEN_NAME.BOOKING_SUCCESS : SCREEN_NAME.BOOKED_DEAL_DETAIL,
        action: DO_CLICK_ACTIONS.DEAL_DETAIL,
        label: CLICK_LABELS.DONE_CLICK,
        context: JSON.stringify({
            bookingId: orderId,
            restId: restaurantId,
            eventId,
            dealCategory,
            guests,
        }),
    });
};

export const impressionQrCode = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { orderId, restaurantId, eventId, dealCategory, guests }: IEventContext,
): void => {
    impressionEvent({
        category: SCREEN_NAME.BOOKED_DEAL_DETAIL,
        action: DO_IMPRESSION_ACTIONS.BOOKING_DETAILS,
        label: IMPRESSION_LABELS.QR_VIEW,
        context: JSON.stringify({
            bookingId: orderId,
            restId: restaurantId,
            eventId,
            dealCategory,
            guests,
        }),
    });
};
